import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eed8092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container content developer-cards" }
const _hoisted_2 = { class: "items-in-line gap--0 flex-start" }
const _hoisted_3 = { class: "developer-cards__title" }
const _hoisted_4 = {
  key: 0,
  class: "developer-cards__container"
}
const _hoisted_5 = {
  key: 1,
  class: "developer-cards__container"
}

import {
  LoadingMediumDeveloperCard,
  MediumDeveloperCard,
} from '@/components/Cards/MediumCards';
import { onMounted, Ref, ref } from 'vue';
import { useDevelopersStore } from '@/store/modules/developers';
import { SmallDeveloperCardType } from '@/types';
import { ListDataType } from '@/api/developer/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeveloperCards',
  setup(__props) {

const isDevelopersLoading = ref(false);
const isMoreLoading = ref(false);
const allDevelopers: Ref<SmallDeveloperCardType[]> = ref([]);
const countDevelopers: Ref<undefined | number> = ref(undefined);
const paginationPage = ref(1);
const pageSize = ref(12);
const searchText: Ref<undefined | string> = ref(undefined);

const searchHandler = () => {
  updateDeveloperList({
    page: paginationPage.value,
    pageSize: pageSize.value,
    search: searchText.value,
  });
};

const changePageAndPageSize = (event: {
  page: number;
  pageSize: number;
  showMore?: true;
}) => {
  updateDeveloperList(
    {
      page: event.page,
      pageSize: event.pageSize,
      search: searchText.value,
    },
    event.showMore,
  );
};

const updateDeveloperList = async (data: ListDataType, showMore?: boolean) => {
  isDevelopersLoading.value = true;
  try {
    const res = await useDevelopersStore().searchAllDevelopers(data);

    if (res) {
      if (showMore) {
        allDevelopers.value = [...allDevelopers.value, ...res.developers];
      } else {
        allDevelopers.value = res.developers;
      }

      countDevelopers.value = res.count;
      pageSize.value = res.pageSize;
    }
  } finally {
    isDevelopersLoading.value = false;
  }
};

onMounted(async () => {
  await updateDeveloperList({});
});

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_pagination_group = _resolveComponent("base-pagination-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(`Список застройщиков Ростовской области${countDevelopers.value ? `: ${countDevelopers.value}` : ''}`), 1)
    ]),
    _createElementVNode("div", null, [
      (isDevelopersLoading.value)
        ? (_openBlock(), _createBlock(_component_base_skeleton_loader, {
            key: 0,
            style: { height: '30px', width: '100%' },
            type: "mediumText"
          }))
        : (_openBlock(), _createBlock(_component_base_input, {
            key: 1,
            modelValue: searchText.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
            appendIcon: "search",
            label: "Поиск по названию",
            onBlur: searchHandler
          }, null, 8, ["modelValue"]))
    ]),
    (isDevelopersLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
            return _createVNode(_unref(LoadingMediumDeveloperCard), { key: i })
          }), 64))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDevelopers.value, (developer, i) => {
            return (_openBlock(), _createBlock(_unref(MediumDeveloperCard), {
              key: i,
              developer: developer
            }, null, 8, ["developer"]))
          }), 128))
        ])),
    _createVNode(_component_base_pagination_group, {
      customPage: paginationPage.value,
      isLoading: isDevelopersLoading.value,
      isMoreLoading: isMoreLoading.value,
      itemCountOnPage: 12,
      "max-for-visible": countDevelopers.value,
      "min-for-visible": 4,
      objectCount: countDevelopers.value,
      "step-for-visible": 4,
      value: paginationPage.value,
      values: allDevelopers.value,
      "auto-add-mobile": "",
      onChangePageAndPageSize: _cache[1] || (_cache[1] = ($event: any) => (changePageAndPageSize($event)))
    }, null, 8, ["customPage", "isLoading", "isMoreLoading", "max-for-visible", "objectCount", "value", "values"])
  ]))
}
}

})